import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const EventDetails = ({ date, time, duration, skillLevel, description, facilityInfo, equipment }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 rounded-lg bg-muted">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="CalendarIcon" size={18} className="text-primary" />
            <span className="text-xs font-medium text-muted-foreground caption">날짜</span>
          </div>
          <p className="text-sm font-semibold text-foreground">{date}</p>
        </div>

        <div className="p-4 rounded-lg bg-muted">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="ClockIcon" size={18} className="text-primary" />
            <span className="text-xs font-medium text-muted-foreground caption">시간</span>
          </div>
          <p className="text-sm font-semibold text-foreground">{time}</p>
        </div>

        <div className="p-4 rounded-lg bg-muted">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="ClockIcon" size={18} className="text-primary" />
            <span className="text-xs font-medium text-muted-foreground caption">소요시간</span>
          </div>
          <p className="text-sm font-semibold text-foreground">{duration}</p>
        </div>

        <div className="p-4 rounded-lg bg-muted">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="ChartBarIcon" size={18} className="text-primary" />
            <span className="text-xs font-medium text-muted-foreground caption">실력</span>
          </div>
          <p className="text-sm font-semibold text-foreground">{skillLevel}</p>
        </div>
      </div>

      <div className="space-y-3">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="DocumentTextIcon" size={20} className="text-primary" />
          상세 설명
        </h3>
        <p className="text-sm text-foreground leading-relaxed whitespace-pre-line">{description}</p>
      </div>

      <div className="space-y-3">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="BuildingOfficeIcon" size={20} className="text-primary" />
          시설 정보
        </h3>
        <p className="text-sm text-muted-foreground leading-relaxed">{facilityInfo}</p>
      </div>

      <div className="space-y-3">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="ShoppingBagIcon" size={20} className="text-primary" />
          준비물
        </h3>
        <div className="flex flex-wrap gap-2">
          {equipment.map((item, index) => (
            <span
              key={index}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-muted text-sm text-foreground"
            >
              <Icon name="CheckCircleIcon" size={16} className="text-success" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
